/*
 * Code is being shared for FAQs & Content Accordion blocks
 */

document.addEventListener("DOMContentLoaded", function () {

	var linkToggle = document.querySelectorAll('.accordion-click');
  
	for(i = 0; i < linkToggle.length; i++){
  
	  linkToggle[i].addEventListener('mousedown', function(event){
		event.preventDefault();
  
		if (event.target.tagName.toLowerCase() === 'a') {
			return; // Exit the function if an <a> tag was clicked
		}

		accordion(this);
  
	  });
  
	  linkToggle[i].addEventListener('keypress', function(event){
  
		if (event.key === "Enter" || event.key === " ") {
  
		  event.preventDefault();
  
		  accordion(this);
  
		}
	  });
	}
  
	function accordion(t){
	  var container = document.getElementById(t.dataset.container);
  
		if (!container.classList.contains('active')) {
		  
		  container.classList.add('active');
		  t.classList.remove('closed');
		  t.classList.add('opened');
		  t.setAttribute("aria-expanded", "true");
		  container.style.height = 'auto';
  
		  var height = container.clientHeight + 'px';
  
		  container.style.height = '0px';
  
		  setTimeout(function () {
			container.style.height = height;
		  }, 0);
		  
		} else {
		  
		  container.style.height = '0px';
		  t.classList.remove('opened');
		  t.classList.add('closed');
		  t.setAttribute("aria-expanded", "false");
  
		  container.addEventListener('transitionend', function () {
			container.classList.remove('active');
		  }, {
			once: true
		  });
		  
		}
	}
  });
  